import React from 'react';
import { CURRENT_EVENTS_ENABLED } from '../../data/events/currentEvents/currentEventsIndex';
import CurrentEventsSection from '../../components/layout/CurrentEventsSection';
import PageHeader from '../../components/layout/PageHeader';
import { getGoogleMapsLanguageParam } from '../../utils/language';
import pageContent from '../../cms/page-content.json';
import '../../css/events/ProgramCalendar.css';

const ProgramCalendar = () => {
  return (
    <>
      <PageHeader
        title={pageContent.programCalendarTitle}
        subtitle={pageContent.programCalendarSubtitle}
        showLogo={true}
      />
      <div className="program-calendar-container">
        {/* Current Events Section - Same as home page */}
        {CURRENT_EVENTS_ENABLED && (
          <CurrentEventsSection />
        )}

        {/* Calendar Section - Untouched */}
        <section className="calendar-section">
          <h2 className="section-title">{pageContent.programCalendarSectionTitle}</h2>
          <div className="calendar-container">
            <iframe
              className="calendar-frame"
              src={`https://calendar.google.com/calendar/embed?src=jhuhillel%40gmail.com&ctz=America%2FNew_York${getGoogleMapsLanguageParam()}`}
              title="Hopkins Hillel Calendar"
            />
          </div>
        </section>
      </div>
    </>
  );
};

export default ProgramCalendar; 